import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ArrowLeft, Save } from 'lucide-react';
import { useCreateLender } from '../../hooks/useLenders';
import PageHeader from '../../components/common/PageHeader';

interface LenderFormValues {
  name: string;
  displayName: string;
}

export default function LenderCreatePage() {
  const navigate = useNavigate();
  const createLender = useCreateLender();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LenderFormValues>();

  const onSubmit = (values: LenderFormValues) => {
    createLender.mutate(values, {
      onSuccess: (lender) => {
        navigate(`/lenders/${encodeURIComponent(lender.urn)}`);
      },
    });
  };

  return (
    <div>
      <PageHeader
        title="Create Lender"
        actions={
          <button onClick={() => navigate('/lenders')} className="btn-secondary gap-1">
            <ArrowLeft className="h-4 w-4" />
            Back
          </button>
        }
      />

      <form onSubmit={handleSubmit(onSubmit)} className="max-w-lg space-y-4 lg:space-y-6">
        <div className="card p-4 lg:p-6">
          <h2 className="text-base lg:text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3 lg:mb-4">Lender Information</h2>
          <div className="space-y-4">
            <div>
              <label className="label">Name *</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. acme-lending"
                {...register('name', { required: 'Name is required' })}
              />
              {errors.name && <p className="text-sm text-red-500 mt-1">{errors.name.message}</p>}
            </div>
            <div>
              <label className="label">Display Name *</label>
              <input
                type="text"
                className="input"
                placeholder="e.g. Acme Lending Corp"
                {...register('displayName', { required: 'Display name is required' })}
              />
              {errors.displayName && (
                <p className="text-sm text-red-500 mt-1">{errors.displayName.message}</p>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => navigate('/lenders')} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" disabled={createLender.isPending} className="btn-primary gap-1">
            <Save className="h-4 w-4" />
            {createLender.isPending ? 'Creating...' : 'Create Lender'}
          </button>
        </div>

        {createLender.isError && (
          <p className="text-sm text-red-500">
            Failed: {(createLender.error as Error).message}
          </p>
        )}
      </form>
    </div>
  );
}
